export const GET_SEASON_COMPANIES = 'app/Seasons/GET_SEASON_COMPANIES';
export const GET_SEASON_COMPANIES_BY_COUNTRY_SLUG = 'app/Seasons/GET_SEASON_COMPANIES_BY_COUNTRY_SLUG';
export const GET_SEASON_COUNTRIES = 'app/Seasons/GET_SEASON_COUNTRIES';
export const GET_SEASONS = 'app/Seasons/GET_SEASONS';
export const GET_SEASONS_PRODUCTION = 'app/Seasons/GET_SEASONS_PRODUCTION';
export const GET_SEASONS_WITH_PRODUCTION = 'app/Seasons/GET_SEASONS_WITH_PRODUCTION';
